import { Component, Injectable, Input } from '@angular/core';
import { NgbActiveModal, ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { BlockGroupService } from '../../../../../../../app/services/block.group.service';
import { BindComponentService } from '../../../../../../../app/utils/bind.component.service';
import { AlertService } from '../../../../../../../app/utils/alert.service';
import { LoadingComponent } from '../../../../modalLoading/content.component';
import { DataPackLineAcount } from '../../../../../../models/dataPackLineAcount.model';

/**
 * @author Edivaldo Mascarenhas
 * @version $Id: content.component.ts 79366 2018-02-17 00:40:37Z edivaldo.m.junior $
 */
 @Component({
  selector:     'confirmMassiveBlockConfigurationComponent',
  templateUrl: './content.modal.template.html'
})
@Injectable()
export class ConfirmMassiveBlockConfigurationComponent {

  @Input() dataLineAcount: DataPackLineAcount;

  private updating: boolean;

  constructor(private activeModal: NgbActiveModal, private alertService: AlertService, private bindComponent: BindComponentService, private modalService: NgbModal, private blockGroupService: BlockGroupService) {
  }

  private close() {
    this.activeModal.dismiss();
  }

  public update() {
    this.updating = true;
    this.openModalLoading();
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
    this.blockGroupService.saveLockVoice(this.dataLineAcount).subscribe(data => {
      this.updating = false;
      this.activeModal.close();
      this.alertService.success('Atualizado com Sucesso!');
      this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
      this.bindComponent.set(BindComponentService.OPEN_SCREEN_BLOC_VOICE, false);
    },
      err => {
        this.updating = false;
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.activeModal.close();
        this.alertService.error(err.result, err);
      }
    );
  }

  private openModalLoading() {
    this.modalService.open(LoadingComponent, {
      backdrop: 'static',
      keyboard: false,
    });
  }

}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/block/voice/config/confirm/content.component.ts